import { apiGet } from "./http";

export interface DataReportsPayload {
  assocName: string;
  generatedAt: string;
  months: number;
  coreMetrics: {
    totalMembers: number;
    activeMembers: number;
    newMembersThisMonth: number;
    newMembersPrevMonth: number;
    publishedActivitiesCount: number;
    churnWarning: number;
    growthPct: number;
  };
  memberGrowth: { month: string; newCount: number; activeCount: number; total: number }[];
  maxNew: number;
  maxActive: number;
  genderDistribution: { label: string; value: number; pct: number }[];
  ageDistribution: unknown[];
  memberLevelData: { label: string; value: number; color: string; hex: string }[];
  memberLevelTotal: number;
  activityData: { name: string; date: string; enrolled: number; capacity: number; attended: number; revenue: string }[];
  activityAnalysis: {
    shortName: string;
    fullName: string;
    type: string;
    enrollRate: number;
    attendRate: number | null;
    capacity: number;
    enrolled: number;
    attended: number | null;
  }[];
  activityTypeStats: {
    type: string;
    count: number;
    avgEnrollRate: number;
    avgAttendRate: number;
    color: string;
    light: string;
  }[];
  activityHighlights: { icon: string; color: string; label: string; value: string; sub: string }[];
  activitySummary: {
    monthlyActivities: number;
    totalRegistrations: number;
    avgAttendRate: number;
    totalRevenueDisplay: string;
  };
  keyMetrics: { label: string; value: string; status: string }[];
  pointsMonthly: { month: string; issued: number; consumed: number }[];
  pointsMonthlyByLevel: Record<string, { month: string; issued: number; consumed: number }[]>;
  pointsLevelNames: string[];
  pointsSourceDistribution: { label: string; value: number; pct: number }[];
  levelPointsOverview: { label: string; avg: number; total: number; color: string }[];
  topRedeemProducts: { name: string; count: number; points: number; color: string }[];
  redeemSummary: {
    totalOrders: number;
    totalPointsConsumed: number;
    distinctRedeemers: number;
    topName: string;
  };
}

export function fetchDataReports(tenantLegacyId: string, months = 6) {
  return apiGet<DataReportsPayload>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/stats/data-reports?months=${months}`
  );
}
